// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-label[data-v-3a83a332]{color:#666;font-weight:500;transform:translateY(9px)}.subData[data-v-3a83a332]{color:#929292;font-size:12px!important;white-space:nowrap}.v-data-table.disabled[data-v-3a83a332]{opacity:.5;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
